import { Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function PageLoader() {
  const { t } = useTranslation();
  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', py: 8 }}
      role="status"
      aria-label={t('common.loadingAria')}
    >
      <CircularProgress />
    </Box>
  );
}
